const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener noreferrer')
}

export { openInNewTab }
